import httpClient from '../utils/http'
import { handleResponseAsync } from '../utils/HelperUtils'
import { normalize } from 'normalizr'
import { payrollDefaultWorkHourSchema } from './../entities/schema'

export const payrollDefaultWorkHourService = {
    getPayrollDefaultWorkHours,
    getEmployeeDefaultWorkHour,
}

function convertViewModelList(data) {
    const payrollDefaultWorkHourListSchema = [payrollDefaultWorkHourSchema]
    const normalizedData = normalize(data, payrollDefaultWorkHourListSchema)
    return normalizedData.entities
}

function convertViewModel(data) {
    const normalizedData = normalize(data, payrollDefaultWorkHourSchema)
    return normalizedData.entities
}

function getPayrollDefaultWorkHours(data) {
    const url = '/api/payrollEmpDefaultWorkHours'

    return httpClient
        .post(url, data)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}


function getEmployeeDefaultWorkHour(options) {
    const { employeeID } = options
    const url = `/api/payrollEmpDefaultWorkHours/${employeeID}`

    // const config = {
    //     url: _url,
    //     headers: {
    //         'content-type': 'application/json',
    //     },
    //     method: 'get',
    // }

    return httpClient
        .get(url)
        .then(handleResponseAsync)
        .then(res => convertViewModel(res.data))
}
